"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFontBold(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm2.06377-.0125h4.98337a9.60324 9.60324 0 0 1 4.945.96929 3.37407 3.37407 0 0 1 1.53886 3.08312 3.88485 3.88485 0 0 1 -.67357 2.35478 2.69071 2.69071 0 0 1 -1.79073 1.1062v.10952a3.52775 3.52775 0 0 1 2.196 1.27049 4.13328 4.13328 0 0 1 .67357 2.47526 4.07884 4.07884 0 0 1 -1.58263 3.41716 6.84466 6.84466 0 0 1 -4.29888 1.22668h-5.991zm3.39523 6.3415h1.97147a3.60443 3.60443 0 0 0 1.99883-.42717 1.59328 1.59328 0 0 0 .61881-1.41283 1.4138 1.4138 0 0 0 -.67358-1.31977 4.3293 4.3293 0 0 0 -2.13025-.39976h-1.78528zm0 2.6943v4.17289h2.2124a3.28168 3.28168 0 0 0 2.07-.53667 1.981 1.981 0 0 0 .6681-1.64287q0-1.99335-2.84764-1.99335z' })));
}
exports.default = SvgFontBold;
